import React from "react";
import {
  ActionList,
  ActionGroup,
  Action,
} from "./../../mood-ui/DataTable";

const SurveyListActions = ({ onClearSelection, onPublish }) => (
  <ActionList onClearSelection={onClearSelection}>
    <ActionGroup>
      <Action label="Publish" onClick={onPublish} />
    </ActionGroup>
  </ActionList>
);

export default SurveyListActions;
